<p-confirmDialog key="import" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<input id="ImportInput" name="ImportInput" type="file" style="display: none" (change)="onFileToImportChange($event)" />

<!--Instructions-->
<div class="TopBorder">
	<h4 style="text-align: center">Example Format:</h4>
	<table>
		<tr>
			<th>
				<label> 1 </label>
			</th>
			<th>
				<label> 2 </label>
			</th>
			<th>
				<label> 3 </label>
			</th>
			<th>
				<label> 4 </label>
			</th>
			<th>
				<label> 5 </label>
			</th>
		</tr>
		<tr>
			<th>
				<label> School Number </label>
			</th>
			<th>
				<label> Locker Number </label>
			</th>
			<th>
				<label> Locker Comments </label>
			</th>
			<th>
				<label> Student ID (If being assigned) </label>
			</th>
			<th>
				<label> Combination (If being assigned) </label>
			</th>
		</tr>
		<tr>
			<th>
				<label> ex. 10M45 </label>
			</th>
			<th>
				<label> ex. A123 </label>
			</th>
			<th>
				<label> ex. Good Condition </label>
			</th>
			<th>
				<label> ex. 12345678 </label>
			</th>
			<th>
				<label> ex. 35-2-24 </label>
			</th>
		</tr>
	</table>
</div>

<!--Options-->
<div class="FileSelectDiv">
	<label>File to Import:</label>
	<div>
		<label *ngIf="ImportFile" style="color: blue; margin-right: 10px">{{ ImportFile?.name }}</label>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSelectFile()">Select File</button>
	</div>

	<label>Format:</label>
	<select
		[disabled]="IsLoading() == true"
		class="form-control"
		name="FormatOptionID"
		[(ngModel)]="FormatOptionID"
		(ngModelChange)="onFormatOptionIDChange($event)"
	>
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>
</div>

<div style="text-align: center">
	<h4>Preview</h4>
</div>
<!--Preview Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstLocker"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedLocker"
		dataKey="UID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--LockerNum-->
				<th>
					<p-columnFilter type="text" field="LockerNum" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LockerComments-->
				<th>
					<p-columnFilter type="text" field="LockerComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AssignedComments-->
				<th>
					<p-columnFilter type="text" field="AssignedComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentName-->
				<th>
					<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentActiveDesc-->
				<th>
					<p-columnFilter field="StudentActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStudentActiveDesc
								[ngModel]="value"
								[options]="lstStudentActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ValidEntryDesc-->
				<th>
					<p-columnFilter field="ValidEntryDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterValidEntryDesc
								[ngModel]="value"
								[options]="lstValidEntryDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ProgressDesc-->
				<th>
					<p-columnFilter field="ProgressDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterProgressDesc
								[ngModel]="value"
								[options]="lstProgressDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LockerNum">Locker<p-sortIcon field="LockerNum"></p-sortIcon></th>
				<th pSortableColumn="LockerComments">Locker Comments<p-sortIcon field="LockerComments"></p-sortIcon></th>
				<th pSortableColumn="AssignedComments">Assigned Comments (Combination)<p-sortIcon field="AssignedComments"></p-sortIcon></th>
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="StudentName">Name<p-sortIcon field="StudentName"></p-sortIcon></th>
				<th pSortableColumn="StudentActiveDesc">Active<p-sortIcon field="StudentActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="ValidEntryDesc">Valid Entry<p-sortIcon field="ValidEntryDesc"></p-sortIcon></th>
				<th pSortableColumn="ProgressDesc">Progress<p-sortIcon field="ProgressDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Locker>
			<tr [pSelectableRow]="Locker" (dblclick)="onRowDblClick(Locker)">
				<td *ngFor="let col of cols1" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Locker[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Locker.StudentActive == true ? 'Black' : 'Red'">
					{{ Locker["StudentActiveDesc"] }}
				</td>

				<td *ngFor="let col of cols2" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Locker[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-success" style="margin-left: 5px" (click)="onFinishImport()">Finish Import</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
